module.exports = __webpack_public_path__ + "static/media/solana.2861a54c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/solana.svg
// module id = 857
// module chunks = 7